import { Component, effect } from '@angular/core';
import { PageRoutes } from '../../../core/constants/pages-routes';
import { RouterModule } from '@angular/router';

import { OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { UserService } from '../../../core/services/users.service';
import { UserRole } from '../../../core/constants/userRole';
import { NgxPermissionsAllowStubDirective, NgxPermissionsModule } from "ngx-permissions";
import { UserAccess } from '../../../core/constants/userAccess';

@Component({
  selector: 'app-sidebar',
  imports: [RouterModule, NgxPermissionsAllowStubDirective, NgxPermissionsModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.less',
})

export class SidebarComponent implements OnInit {
  pageRoutes = PageRoutes;
  UserAccess = UserAccess;
  
  toogleSidePannel() {
    const mainLayout = document.getElementById('main-wrapper');
    if (mainLayout?.classList.contains('active')) {
      mainLayout?.classList?.remove('active');
    } else {
      mainLayout?.classList?.add('active');
    }
  }

  openSubmenu: string = PageRoutes.SETUP;
  userDetails: any;
  UserRole = UserRole;

  constructor(private router: Router, private userService: UserService) {
    effect(() => {
      const userDetails = this.userService.loggedInUserDetails();
      if (userDetails) {
        this.userDetails = userDetails;
      }
    });
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.syncSubmenuWithRoute();
      });

    this.syncSubmenuWithRoute();
  }

  /** Toggle submenu */
  toggleSubmenu(key: string) {
    this.openSubmenu = this.openSubmenu === key ? '' : key;
  }

  /** Check active route per submenu */
  isSubmenuRouteActive(key: Exclude<string, null>): boolean {
    const routeMap: Record<Exclude<string, null>, string> = {
      setup: '/' + PageRoutes.SETUP,
    };

    return this.router.url.includes(routeMap[key]);
  }

  /** Auto-open submenu if child route active */
  syncSubmenuWithRoute() {
    const keys: Exclude<string, null>[] = [PageRoutes.SETUP];

    this.openSubmenu = keys.find((key) => this.isSubmenuRouteActive(key)) ?? '';
  }
}
